import zodChecker from '@tpi-dtd/zod-checker'
import { createApp } from 'vue'
import App from '@/app.vue'
import 'bootstrap'
import i18n from '@/locales'
import {
  useDynamicLayout,
  type UseDynamicLayoutPluginOption
} from '@/plugins/use-dynamic-layout'
import router from '@/router'
import { piniaInstance } from '@/stores/pinia-instance'
import '~library/styles/app/style.scss'
import '~library/styles/app-custom/style.scss'
import { useEnv } from '~library/composables'

const { VITE_ENABLE_VUE_PLUGIN_ZOD_CHECKER } = useEnv()

createApp(App)
  .use(i18n)
  .use(piniaInstance)
  .use(router)
  .use<UseDynamicLayoutPluginOption>(useDynamicLayout, {
    router,
    layoutInFolder: true
  })
  .use(zodChecker, {
    isShow: !!VITE_ENABLE_VUE_PLUGIN_ZOD_CHECKER,
    router
  })
  .mount('#app')

// 監聽 vite preloadError 並重新整理網站
window.addEventListener('vite:preloadError', () => {
  location.reload()
})
